import { motion } from "framer-motion";
import { Flame, ArrowRight } from "lucide-react";
import { goToCheckout } from "../../lib/tracking";

const sizes = {
  sm: "px-5 py-2.5 text-sm",
  md: "px-7 py-3.5 text-base",
  lg: "px-6 py-4 text-base sm:px-9 sm:text-lg",
  xl: "px-8 py-4 text-lg sm:px-12 sm:py-5 sm:text-xl",
};

export const CTAButton = ({ source, size = "lg", className = "", children, testId, variant = "primary" }) => {
  const base =
    variant === "primary"
      ? "cta-pulse bg-gradient-to-r from-blue-600 via-blue-500 to-cyan-500 text-white"
      : "bg-white text-blue-700 shadow-[0_8px_30px_rgba(0,0,0,0.15)]";
  return (
    <motion.button
      whileHover={{ scale: 1.04, y: -2 }}
      whileTap={{ scale: 0.96 }}
      onClick={() => goToCheckout(source)}
      data-testid={testId}
      className={`inline-flex items-center justify-center gap-2.5 rounded-full font-bold tracking-wide transition-shadow ${base} ${sizes[size]} ${className}`}
    >
      <Flame className="w-5 h-5 shrink-0" strokeWidth={2.5} />
      <span className="whitespace-nowrap">{children || "ORDER SEKARANG"}</span>
      <ArrowRight className="w-5 h-5 shrink-0" strokeWidth={2.5} />
    </motion.button>
  );
};
